// extracted by mini-css-extract-plugin
module.exports = {"startIcon":"Button_startIcon__VhQ1V","endIcon":"Button_endIcon__2xrC7"};